import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './FolderBar';
import { unsetSelectedFolderId } from '../../../../actions/gallectionSection';
import { AppState } from '../../../../../types/store';
import {
  getCurrentlyViewedFolderId,
  getGallectionSectionType,
} from '../../../../selectors/gallectionSection';
import { getFolderById } from '../../../../selectors/folders';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { getCoreLevel } from '@wix/da-shared-react/pkg/publicSession';

type StateProps = Pick<
  Props,
  'currentFolder' | 'profileOwner' | 'isCurrentUserProfileOwner' | 'coreLevel'
>;
type DispatchProps = Pick<Props, 'unsetSelectedFolderId'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const currentlyViewedFolderId = getCurrentlyViewedFolderId(state);
  const currentFolder =
    ownProps.currentFolder ||
    (typeof currentlyViewedFolderId === 'number'
      ? getFolderById(
          state,
          getGallectionSectionType(state),
          currentlyViewedFolderId
        )
      : undefined);

  return {
    currentFolder,
    coreLevel: getCoreLevel(state),
    profileOwner: getProfileOwnerUser(state),
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  unsetSelectedFolderId,
};

export default connect(mapStateToProps, mapDispatchToProps);
